import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ThorRuneRazeView} from "./ThorRuneRazeView";
import {ThorRespinNudgeReelController} from "../../reel/nudgereel/ThorRespinNudgeReelController";

/**
 * Created by Jerker Nord on 2019-04-10.
 */

export class ThorRuneRazeController extends BeforeSpinStopPresentationController {

    private _reelSetName:string;
    private _runeRazeView:ThorRuneRazeView;
    private _runeRazeSymbol:string;

    constructor(index:number) {
        super(index, "ThorRuneRazeController");
        this._runeRazeView = new ThorRuneRazeView();
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        if(data.runeRazeTriggered == true) {
            this._runeRazeSymbol = data.runeRazeSymbol;
            this._reelSetName = this.getReelSetName(this._runeRazeSymbol);
        }
        return data.runeRazeTriggered;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 4 : 5.5;
    }

    protected startPresentation(timeline:TimelineLite):void {
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : this._reelSetName})), "+=1");
        timeline.add(()=>this._runeRazeView.getShowRuneRazeTL(this._runeRazeSymbol));
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRespinNudgeReelController.ENABLE_LIT_SYMBOL, this._runeRazeSymbol)), "-=0.7");
    }

    private getReelSetName(runeRazeSymbol:string):string {
        switch(runeRazeSymbol) {
            case "L1" :
                return "RUNE_RAZE_L1";

            case "L2" :
                return "RUNE_RAZE_L2";

            case "L3" :
                return "RUNE_RAZE_L3";

            case "L4" :
                return "RUNE_RAZE_L4";

            case "L5" :
                return "RUNE_RAZE_L5";

            default :
                return "BASE_REELSET";
        }
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            this._runeRazeView.abort();
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}